/**
  * Returns the content for meta tag
  */
 export default function(name) {
  const tag = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  return tag && tag.content;
}
